<div class="account-deletion">
  <h1>{{ 'ACCOUNT_DELETION.TITLE' | translate }}</h1>
  <p class="intro">{{ 'ACCOUNT_DELETION.DESCRIPTION' | translate }}</p>

  <nz-alert
    nzType="warning"
    nzShowIcon
    [nzMessage]="'ACCOUNT_DELETION.WARNING' | translate"
    class="warning"
  ></nz-alert>

  <!-- SaaS retention block -->
  <nz-alert
    nzType="info"
    nzShowIcon
    [nzMessage]="'ACCOUNT_DELETION.RETENTION_HINT' | translate"
    class="info"
  ></nz-alert>

  <div class="actions-row">
    <button
      nz-button
      nzType="default"
      class="deactivate-btn"
      (click)="deactivate()"
      [nzLoading]="isDeactivating"
      [disabled]="isDeactivating || isDeleting"
    >
      {{ 'ACCOUNT_DELETION.DEACTIVATE_BUTTON' | translate }}
    </button>

    <a class="support-link" href="mailto:contact@scanafy.de">
      {{ 'ACCOUNT_DELETION.CONTACT_SUPPORT' | translate }}
    </a>
  </div>

  <form nz-form [formGroup]="form" (ngSubmit)="submit()" class="deletion-form">
    <!-- reason -->
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzFor="reason" nzRequired>
        {{ 'ACCOUNT_DELETION.REASON_LABEL' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24" [nzErrorTip]="reasonErrorTpl">
        <nz-select
          id="reason"
          formControlName="reason"
          [nzPlaceHolder]="'ACCOUNT_DELETION.REASON_PLACEHOLDER' | translate"
        >
          <nz-option nzValue="too_expensive" [nzLabel]="'ACCOUNT_DELETION.REASONS.TOO_EXPENSIVE' | translate"></nz-option>
          <nz-option nzValue="too_complex" [nzLabel]="'ACCOUNT_DELETION.REASONS.TOO_COMPLEX' | translate"></nz-option>
          <nz-option nzValue="missing_feature" [nzLabel]="'ACCOUNT_DELETION.REASONS.MISSING_FEATURE' | translate"></nz-option>
          <nz-option nzValue="no_longer_needed" [nzLabel]="'ACCOUNT_DELETION.REASONS.NO_LONGER_NEEDED' | translate"></nz-option>
          <nz-option nzValue="technical_issues" [nzLabel]="'ACCOUNT_DELETION.REASONS.TECHNICAL_ISSUES' | translate"></nz-option>
          <nz-option nzValue="other" [nzLabel]="'ACCOUNT_DELETION.REASONS.OTHER' | translate"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <ng-template #reasonErrorTpl>
      <ng-container *ngIf="form.get('reason')?.hasError('required')">
        {{ 'ACCOUNT_DELETION.REASON_REQUIRED' | translate }}
      </ng-container>
    </ng-template>

    <!-- optional feedback -->
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzFor="feedback">
        {{ 'ACCOUNT_DELETION.FEEDBACK_LABEL' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <textarea
          nz-input
          id="feedback"
          rows="3"
          formControlName="feedback"
          [placeholder]="'ACCOUNT_DELETION.FEEDBACK_PLACEHOLDER' | translate"
        ></textarea>
      </nz-form-control>
    </nz-form-item>

    <!-- phrase -->
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzFor="confirmationText" nzRequired>
        {{ 'ACCOUNT_DELETION.CONFIRMATION_LABEL' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24" [nzErrorTip]="confirmationErrorTpl">
        <input
          nz-input
          id="confirmationText"
          formControlName="confirmationText"
          [placeholder]="'ACCOUNT_DELETION.CONFIRMATION_PLACEHOLDER' | translate:{ phrase: confirmationPhrase }"
        />
      </nz-form-control>
    </nz-form-item>

    <ng-template #confirmationErrorTpl>
      <ng-container *ngIf="form.get('confirmationText')?.hasError('required')">
        {{ 'ACCOUNT_DELETION.CONFIRMATION_REQUIRED' | translate }}
      </ng-container>
      <ng-container *ngIf="form.get('confirmationText')?.hasError('confirmationMismatch')">
        {{ 'ACCOUNT_DELETION.CONFIRMATION_MISMATCH' | translate:{ phrase: confirmationPhrase } }}
      </ng-container>
    </ng-template>

    <button
      nz-button
      nzType="primary"
      class="delete-btn"
      [disabled]="form.invalid || isDeleting"
      [nzLoading]="isDeleting"
    >
      {{ 'ACCOUNT_DELETION.SCHEDULE_DELETE_BUTTON' | translate }}
    </button>

    <p class="cooldown-note">
      {{ 'ACCOUNT_DELETION.COOLDOWN_NOTE' | translate:{ days: deletionCooldownDays } }}
    </p>
  </form>
</div>
